import { render, staticRenderFns } from "./LegendOeeGraphDialog.vue?vue&type=template&id=f52ede04&scoped=true"
import script from "./LegendOeeGraphDialog.vue?vue&type=script&lang=js"
export * from "./LegendOeeGraphDialog.vue?vue&type=script&lang=js"
import style0 from "./LegendOeeGraphDialog.vue?vue&type=style&index=0&id=f52ede04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f52ede04",
  null
  
)

export default component.exports